// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gifContainer_wrapper__3d4uF","media":"gifContainer_media__3asR3"};